import { useEffect, useState } from "react";
import { getAllData, postUsersData, patchUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { formatDate, generatePDF, getDateCombination, isImageValidPng } from '../../commonClass/CommonValidation'
import { useRef } from 'react';
import { CommonFileURLWithFolder, ImageDelete, ImageUpload } from '../../../ImageUpload/ImageCommon';
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ExportExcel } from '../../commonClass/ExportExcel';
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import CustomTable from '../../../customControl/CustomTable';
import CommonFilter from '../../../customControl/CommonFilter';

const Thememaster = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const inputRef = useRef();
    const [themedata, setThemeData] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [imageFileName, setImageFileName] = useState();
    const [disabled, setDisabled] = useState(false);
    const [editdisabled, setEditDisabled] = useState(true);
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [searchvalue, setSearchValue] = useState();
    const [searchby, setSerachBy] = useState('All');
    const [serchdisable, setSerachDisable] = useState(false);
    const [filteritems, setFilterItems] = useState([]);
    const [imagedelete, setImageDelete] = useState('');
    const [imagepath, setImagePath] = useState('');
    const [imageduplicateerrorMessage, setImageDuplicateErrorMessage] = useState('');
    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    const [formValue, setFormValue] = useState(
        {
            LanguageId: 1,
            ThemeId: 0,
            ThemeName: '',
            ImageFileName: '',
            ImagePath: '',
            IsActive: false
        }
    );

    const columns = [

        {
            name: 'Theme Name',
            key: 'themeName',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (image) => image.themeName
        },

        {
            name: 'Active',
            key: 'IsActiveFormat',
            sortable: true,
            float: "left",
            selector: (image) => image.IsActiveFormat
        },
        {
            name: 'Created Date',
            key: 'CreatedDateFormat',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (image) => new Date(image.createdDate),
            format: (image) => image.CreatedDateFormat,
        },
        {
            name: 'Edit',
            selector: (image) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditMode(image.themeId)}></i></button>
        },
        {
            name: 'View',
            selector: (image) => <button type='button' className='border-0 p-0 bg-body set_disableclr'><i className="fa fa-eye" onClick={() => handleViewMode(image.themeId)}></i></button>
        }
    ];

    const [isSubmit, setIsSubmit] = useState(false);
    const [formErrors, setFormErrors] = useState({});

    //#region handle getbannerdata
    useEffect(() => {
        dispatch(loaderActions.start());
        let token = GetLocalStorage();
        if (token && token.userName && token.token) {
            getImageDataList().then(() => { dispatch(loaderActions.end()) });
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }

    }, []);

    const getImageDataList = async () => {
        const imagelistdata = await getAllData("/master/v1/getalltheme");
        imagelistdata?.data?.map((obj) => {
            obj.IsActiveFormat = obj?.isActive ? 'Active' : 'InActive';
            obj.CreatedDateFormat = formatDate(obj?.createdDate);
            return obj;
        })
        setThemeData(imagelistdata.data);
        setFilterItems(imagelistdata.data);
    }

    useEffect(() => {
        let pagelink = user?.find(x => {
            if (x.PageLink === window.location.pathname)
                return x.MenuId
        });
        let mid = user?.find(x => x.MenuId === pagelink.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);

        });
    }, [user])
    //#endregion

    //#region image upload

    const [fileselected, setSelectedFile] = useState();

    const handleUploadImageLoad = (e) => {
        let error = {}
        if (isImageValidPng(e.target.files[0].name)) {
            const files = e.target.files;
            const filename = getDateCombination(files?.[0]?.name);
            formValue.ImageFileName = filename
            formValue.ImagePath = 'CMS/Theme/' + filename
            setSelectedFile(e.target.files[0]);
            setEditDisabled(true);
            setImagePath('');
            setImageFileName('');
            setImageDuplicateErrorMessage('');
        }
        else {
            document.getElementById("ImagePath").value = "";
            setFormValue({ ...formValue, ImageFileName: '', ImagePath: '' });
            setImagePath('');
            setImageFileName('');
            error.ImagePath = "Only PNG file type is accepted.";
            setFormErrors(error);
            setIsSubmit(false);
            setImageDuplicateErrorMessage('');
            return;
        }
    }

    useEffect(() => {
        setFormErrors('');
    }, [fileselected]);

    const removeImage = () => {
        document.getElementById("ImagePath").value = "";
        formValue.ImagePath = ''
        formValue.ImageFileName = ''
        setImagePath('');
        setSelectedFile();
        setEditDisabled(true);
        setImageFileName('');
    };
    //#endregion

    //#region handle change and active value
    const onChange = (e) => {
        setFormValue({ ...formValue, [e.target.name]: e.target.value });
        setFormErrors('');
        setImageDuplicateErrorMessage('');
        setEditDisabled(true);
    }

    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            setFormValue((form) => ({ ...form, IsActive: e }))
            setFormErrors('');
            setImageDuplicateErrorMessage('');
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            setFormValue((form) => ({ ...form, IsActive: !formValue?.IsActive }))
            setFormErrors('');
            setImageDuplicateErrorMessage('');
            setEditDisabled(true);
        }
        setModalShow(false);
    }
    //#endregion

    //#region handle Add,Retrive, Edit, View
    const handleSubmitData = async () => {
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (buttonaddeditText === 'Add') {
            if (statusoftoken) {
                let status = false;
                const Themedata = await postUsersData('/master/v1/inserttheme', formValue)
                status = Themedata.status;
                if (status !== 400) {
                    try {
                        if (!Themedata.status && !Themedata.data) {
                            setImageDuplicateErrorMessage(Themedata.message);
                            setDisabled(false);
                            setEditDisabled(true);
                            setIsSubmit(false);
                            return;
                        }
                        if (Themedata.status) {
                            if (Themedata.data > 0) {
                                await ImageUpload('CMS/Theme/', formValue.ImageFileName, fileselected);
                                dispatch({ type: 'ALERTING', message: Themedata.message })
                                clear();
                            }
                            else {
                                dispatch({ type: 'ALERTING', message: Themedata.message })
                                setIsSubmit(false);
                                return;
                            }
                        }

                    }
                    catch (err) {
                        dispatch({ type: 'ALERTING', message: err })
                        setDisabled(false);
                        setEditDisabled(true);
                        dispatch(loaderActions.end());
                        return;
                    }

                }
                else {
                    dispatch({ type: 'ALERTING', message: Themedata.message })
                    setDisabled(false);
                    setEditDisabled(true);
                    return;
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        else {
            if (statusoftoken) {
                try {
                    let status1 = false;
                    const Themedata = await patchUsersData('/master/v1/updatetheme', formValue)
                    status1 = Themedata.status;
                    if (status1 !== 400 && typeof status1 != 'undefined') {
                        try {
                            if (!Themedata.status && !Themedata.data) {
                                setImageDuplicateErrorMessage(Themedata.message);
                                setDisabled(false);
                                setEditDisabled(true);
                                setIsSubmit(false);
                                return;
                            }
                            if (Themedata.status) {
                                if (imagepath?.length === 0) {
                                    await ImageUpload('CMS/Theme/', formValue.ImageFileName, fileselected);
                                }

                                try {
                                    if (imagepath?.length === 0) {
                                        await ImageDelete(imagedelete);
                                    }
                                }
                                catch (err) {
                                    dispatch({ type: 'ALERTING', message: err })
                                    setDisabled(false);
                                    setEditDisabled(true);
                                    setIsSubmit(false);
                                    return;
                                }
                                dispatch({ type: 'ALERTING', message: Themedata.message })
                                clear();
                            }

                        }
                        catch (err) {
                            dispatch({ type: 'ALERTING', message: err })
                            setDisabled(false);
                            setEditDisabled(true);
                            setIsSubmit(false);
                            dispatch(loaderActions.end());
                            return;
                        }
                    }
                    else {
                        dispatch({ type: 'ALERTING', message: Themedata.message })
                        setDisabled(false);
                        setEditDisabled(true);
                        setIsSubmit(false);
                        return;
                    }
                }
                catch (err) {
                    dispatch({ type: 'ALERTING', message: err })
                    setDisabled(false);
                    setEditDisabled(true);
                    setIsSubmit(false);
                    dispatch(loaderActions.end());
                    return;
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }

        }
        dispatch(loaderActions.end());

    }

    const onSubmitForm = e => {
        e.preventDefault();
        setFormErrors(validateData(formValue));
    };

    const validateData = (values) => {
        setIsSubmit(true);
        const error = {}
        if (!values.ThemeName || values.ThemeName?.trim()?.length === 0) {
            error.ThemeName = "Please enter Theme Name";
            setIsSubmit(false);
        }
        if (values.ThemeName?.length > 50) {
            error.ThemeName = "Maximum length is 50 characters";
            setIsSubmit(false);
        }
        return error;
    }

    useEffect(() => {
        if (Object.keys(formErrors)?.length === 0 && isSubmit) {
            setDisabled(true);
            setEditDisabled(false);
            handleSubmitData();
        }
        if (Object.keys(formErrors)?.length > 0) {
            let id = Object.keys(formErrors)[0];
            let doc = document.getElementById(id);
            if (doc !== null)
                doc.focus();
        }

    }, [formErrors]);

    const handleEditMode = (id) => {
        setDisabled(false);
        setEditDisabled(false);
        setButtonAddEditText("Update");
        setSerachDisable(true);
        RetriveData(id);
    }

    const handleViewMode = (id) => {
        setDisabled(true);
        setEditDisabled(false);
        setSerachDisable(true);
        RetriveData(id);
    }

    const RetriveData = (id) => {
        document.getElementById("ImagePath").value = "";
        setSelectedFile('');
        setFormErrors('');
        setImageDuplicateErrorMessage('');
        themedata?.map(obj => {
            if (obj.themeId === id) {
                formValue.ThemeName = obj.themeName
                formValue.ImagePath = obj.imagePath
                formValue.ThemeId = obj.themeId
                formValue.IsActive = obj.isActive
                formValue.ImageFileName = obj.imageFileName
                setImagePath(obj.imagePath ? CommonFileURLWithFolder + obj.imagePath : obj.imagePath);
                setImageFileName(obj.imageFileName);
                setImageDelete(obj.imagePath);
            }
        });
        setFormValue({ ...formValue, formValue })
    }

    //#endregion

    //#region handle clear value
    const clear = () => {
        setIsSubmit(false);
        setFormErrors('');
        setImageFileName('');
        setFormValue({ ...formValue, ThemeId: 0, ThemeName: '', ImageFileName: '', ImagePath: '', IsActive: false });
        setSelectedFile();
        setSerachBy('All');
        setSearchValue('');
        setSerachDisable(false);
        setImageDuplicateErrorMessage('');
        setDisabled(false);
        setEditDisabled(true);
        getImageDataList();
        setImageDelete('');
        setButtonAddEditText('Add');
        setImagePath('');
        document.getElementById("ImagePath").value = "";
    }
    //#endregion

    //#region PDF and Excel Export
    const PdfExport = () => {
        const keys = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        const pdfColumns = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const rows = themedata?.map((obj) => keys?.map((key) => obj[key]));
        generatePDF(pdfColumns, rows, "ThemeMaster", "Theme Master");
    }
    const ExportToExcel = () => {
        const dispalyname = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const fields = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        ExportExcel(dispalyname, fields, themedata, "ThemeMaster", "ThemeMaster.xls");
    }
    //#endregion

    return (
        <>
            <div class="container-fluid mt-4 heading_color">
                <h3>Theme Master</h3>
            </div>
            <div class="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div class="mb-3 row mx-1">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="row">
                                {imageduplicateerrorMessage && <div className="text-danger pb-3 text-center"> {imageduplicateerrorMessage} </div>}
                                <div className='col-md-6'>
                                    <div className='row'>

                                        <div class="col-lg-4 col-md-12 col-sm-12">
                                            <label for="inputPassword6" class="col-form-label required">Theme Name</label>
                                        </div>
                                        <div class=" col-lg-8 col-md-12 col-sm-12">
                                            <input type="text" id="ThemeName" class="form-control"
                                                name="ThemeName"
                                                value={formValue.ThemeName}
                                                onChange={onChange}
                                                disabled={disabled ? true : false}
                                                placeholder="Theme Name"
                                            />
                                            {formErrors.ThemeName && <p className='text-danger text-start'>{formErrors.ThemeName}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='row'>
                                        <div class="col-lg-4 col-md-12 mb-1">
                                            <label for="inputPassword6" class="col-form-label">Upload Image</label>
                                        </div>
                                        <div class="col-lg-8 col-md-12 col-sm-12 mb-lg-1 mb-md-1">
                                            <div class="input-group">

                                                <input
                                                    ref={inputRef}
                                                    name='ThemeImage'
                                                    type="file"
                                                    id="ImagePath"
                                                    onChange={handleUploadImageLoad}
                                                    class="form-control btn_add"
                                                    accept=".png"
                                                    disabled={disabled ? true : false}
                                                />
                                                <label class="input-group-text" for="ImagePath">Browse</label>

                                            </div>
                                            {formErrors.ImagePath && <p className='text-danger text-start'>{formErrors.ImagePath}</p>}
                                            {imageFileName && <p className='text-start overflow-hidden' data-bs-toggle="tooltip" data-bs-placement="left" title={imageFileName}>
                                                {imageFileName}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='row'>
                                        <div class="col-lg-4 col-md-12 col-sm-12">
                                            <label for="inputPassword6" class="col-form-label">Active</label>
                                        </div>
                                        <div class="col-auto col-lg-8">

                                            <Switch
                                                onChange={handleisActive}
                                                checked={formValue?.IsActive}
                                                className="react-switch"
                                                disabled={disabled ? true : false}
                                            />
                                        </div>
                                        <ConfirmationModal
                                            show={modalShow}
                                            onHide={() => setModalShow(false)}
                                            noconfirm={() => handleConfirmation(false)}
                                            yesconfirm={() => handleConfirmation(true)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            {fileselected &&
                                (
                                    <div className="col-lg-2 col-md-3 col-6 mx-auto mt-2">
                                        <img src={URL.createObjectURL(fileselected)} className="img_thumb w-100" alt='' />
                                        <button onClick={() => removeImage()} type="button" className='closebtnimg' data-close disabled={disabled ? true : false} >&times;</button>
                                    </div>
                                )}
                            {(!fileselected && imagepath?.trim()?.length > 0) && (
                                <div className="col-lg-2 col-md-3 col-6 mx-auto mt-2" >
                                    <img src={imagepath} className="img_thumb w-100" alt='' />
                                    <button onClick={() => removeImage()} type="button" data-close className='closebtnimg' disabled={disabled ? true : false} >&times;</button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mb-4">
                        {useradd === false && buttonaddeditText === "Add" ?
                            <button type="button" class="btn btn-primary mx-1" id="btnAdd" onClick={onSubmitForm} disabled={!useradd}>{buttonaddeditText}</button> :
                            <button type="button" class="btn btn-primary mx-1" id="btnAdd" onClick={onSubmitForm} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                        <button type="button" class="btn btn-primary mx-1" id="btnClear" onClick={clear} >Clear</button>
                    </div>

                    <CommonFilter
                        columns={columns}
                        filterList={filteritems}
                        searchDisabled={serchdisable}
                        getdata={getImageDataList}
                        setlistdata={setThemeData}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={themedata}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />
                </form>
            </div>
        </>
    )
}

export default Thememaster